import http from '../api/http'

export default {
  list: () => http.get('/countries/list')
}
